export interface Finding {
  id: string; source: string; severity: string; title: string; evidence: string; action: string; refs: string[];
}
export const parameterFields = [
  ['fixedWastage','固定损耗'],['variableWastagePct','变动损耗%'],['cycleTimeS','节拍（秒）'],
  ['productionLine','产线'],['mouldNo','模具'],['supplyOrg','供应组织'],['issueOrg','发料组织'],['ownerOrg','货主组织'],['logisticsOrg','物流组织'],
] as const;
export function parameterComparison(item: Finding, rows: Record<string, any>) {
  const related = item.refs.map(ref=>rows[ref]).filter(Boolean);
  const text = item.title + item.evidence;
  const named = parameterFields.filter(([,label])=>text.includes(label.replace(/[%（].*/,'')));
  return (named.length ? named : parameterFields).map(([field,label])=>{
    const values = new Map<string,number>();
    for (const row of related) { const value=String(row[field] ?? '未填写'); values.set(value,(values.get(value)??0)+1); }
    return {field,label,values:[...values].map(([value,count])=>({value,count}))};
  }).filter(field=>field.values.length>1);
}
export function isMissingParameter(item: Finding): boolean {
  return item.source === 'rule' && item.severity === 'warning' && item.title === '制造参数待确认'
    && item.evidence.startsWith('以下字段未填写：');
}
export function groupFindings(items: Finding[]) {
  const groups = new Map<string, {key: string; title: string; source: string; severity: string; missing: boolean; items: Finding[]; refs: string[]}>();
  for (const item of items) {
    const missing = isMissingParameter(item);
    // Blank-field lists only combine identical instructions. Other groups retain every distinct piece of evidence.
    const key = JSON.stringify([item.source, item.severity, item.title, ...(missing ? [item.evidence, item.action] : [])]);
    if (!groups.has(key)) groups.set(key, {key, title: item.title, source: item.source, severity: item.severity, missing, items: [], refs: []});
    groups.get(key)!.items.push(item);
  }
  return [...groups.values()].map(group => ({...group, refs: [...new Set(group.items.flatMap(item => item.refs))]}))
    .sort((a,b) => rank(a) - rank(b));
}
function rank(group: {severity: string; missing: boolean; source: string}) {
  return group.severity === 'blocker' ? 0 : group.missing ? 4 : group.severity === 'info' ? 3 : group.source === 'rule' ? 1 : 2;
}
export function findingsCsv(items: Finding[], labels: Record<string, any>, decisions: Record<string, any>): string {
  const rows: unknown[][] = [['来源','问题','待确认内容','建议','行引用','表单','上级件','零件号','零件名称','核对意见','核对人']];
  for (const item of items) for (const ref of item.refs.length ? item.refs : ['']) {
    const row = labels[ref] ?? {}, decision = decisions[item.id];
    rows.push([item.source === 'ai' ? 'AI 建议' : '规则检查',item.title,item.evidence,item.action,ref,row.sheet,row.parent,row.partNumber,row.partName,
      decision ? decision.decision === 'checked' ? '已核对' : '不采纳' : '未记录意见',decision?.actor]);
  }
  const cell = (value: unknown) => {
    let text = String(value ?? '');
    if (/^[\s]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g,'""') + '"';
  };
  return '\uFEFF' + rows.map(row => row.map(cell).join(',')).join('\r\n');
}
